import NRDataUseCase from "@domains/salesFeatures/NRDashboard/useCases/NRDataUseCase";
import ProductDataUseCase from "@domains/salesFeatures/NRDashboard/useCases/ProductDataUseCase";
import NRHeaderDataUseCase from "@domains/salesFeatures/NRDashboard/useCases/NRHeaderDataUseCase";
import NRClientLevelUseCase from "@domains/salesFeatures/NRDashboard/useCases/NRClientLevelUseCase";
import NRSummaryUseCase from "@domains/salesFeatures/NRDashboard/useCases/NRSummaryUseCase";
import EmployeeDataUseCase from "@domains/salesFeatures/NRDashboard/useCases/EmployeeDataUseCase";
import LocationdataUseCase from "@domains/salesFeatures/NRDashboard/useCases/LocationdataUseCase";
import FinancialYearUseCase from "@domains/salesFeatures/NRDashboard/useCases/FinancialYearUseCase";
import LobNRUseCase from "@domains/salesFeatures/NRDashboard/useCases/LobNRUseCase";
import PartnerNRSummaryUseCase from "@domains/salesFeatures/PartnerNRDashboard/useCases/PartnerNRSummaryUseCase";
import PartnerNRHeaderUseCase from "@domains/salesFeatures/PartnerNRDashboard/useCases/IPartnerNRHeaderUseCase";
import PartnerNRDownloadUseCase from "@domains/salesFeatures/PartnerNRDashboard/useCases/IPartnerNRDownloadUseCase";
export default (function (repo) {
    return {
        nrDashboard: {
            nrData: new NRDataUseCase(repo.nrDashboard),
            productData: new ProductDataUseCase(repo.nrDashboard),
            nrHeaderData: new NRHeaderDataUseCase(repo.nrDashboard),
            nrClientLevel: new NRClientLevelUseCase(repo.nrDashboard),
            nrSummary: new NRSummaryUseCase(repo.nrDashboard),
            employeeData: new EmployeeDataUseCase(repo.nrDashboard),
            locationData: new LocationdataUseCase(repo.nrDashboard),
            financialYear: new FinancialYearUseCase(repo.nrDashboard),
            lobNR: new LobNRUseCase(repo.nrDashboard),
        },
        partnerNRDashboard: {
            partnerNRSummary: new PartnerNRSummaryUseCase(repo.partnerNRDashboard),
            partnerNRHeader: new PartnerNRHeaderUseCase(repo.partnerNRDashboard),
            partnerNRDownload: new PartnerNRDownloadUseCase(repo.partnerNRDashboard),
        },
    };
});
